import { render, staticRenderFns } from "./IceSelect.vue?vue&type=template&id=537e52b3&scoped=true"
import script from "./IceSelect.vue?vue&type=script&lang=js"
export * from "./IceSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "537e52b3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\G\\YT\\mes-project-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('537e52b3')) {
      api.createRecord('537e52b3', component.options)
    } else {
      api.reload('537e52b3', component.options)
    }
    module.hot.accept("./IceSelect.vue?vue&type=template&id=537e52b3&scoped=true", function () {
      api.rerender('537e52b3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/IceSelect.vue"
export default component.exports